module.exports = __webpack_public_path__ + "static/media/smartphonePixel.881b2468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/smartphonePixel.png
// module id = 807
// module chunks = 1 3